import { Instagram } from 'lucide-react';
import { INSTAGRAM_URL } from './data';

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-ink py-12">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div>
        <img
          src={`${process.env.PUBLIC_URL}/alfredj-logo.png`}
          alt="Alfredj"
          className="h-20 w-auto object-contain"
        />
        <p className="mt-2 text-sm text-[#f1f0ea]/50 max-w-sm">
          DJ de música indie y alternativa en Albacete. Indie-rock · indie-pop · britpop · clásicos alternativos.
        </p>
      </div>
      <div className="flex items-center gap-5">
        <a
          data-testid="footer-instagram"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 border border-white/15 px-5 py-3 text-[#f1f0ea] hover:border-acid hover:text-acid transition-colors"
        >
          <Instagram size={18} /> <span className="uppercase text-sm tracking-widest">Instagram</span>
        </a>
      </div>
    </div>
    <div className="mx-auto max-w-7xl px-5 sm:px-8 mt-10 pt-6 border-t border-white/10 text-xs text-[#f1f0ea]/40 uppercase tracking-widest flex flex-col sm:flex-row justify-between gap-2">
      <span>© {new Date().getFullYear()} Alfredj · Albacete · Todos los derechos reservados</span>
      <a data-testid="footer-admin-link" href="/login" className="hover:text-acid transition-colors">Acceso</a>
    </div>
  </footer>
);
